import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Stack,
  Typography,
} from '@mui/material'
import { Button } from '@loadsmart/loadsmart-ui'
import { MessageAction } from 'common/types/kraken-core/Action'

export interface MessageActionExecutionDialogProps {
  open: boolean
  onClose: () => void
  onExecute: (args: Record<string, string>) => void
  action: MessageAction | undefined
  actionArgs: Record<string, string>
  onUpdateActionArg: (key: string, value: string) => void
}

const MessageActionExecutionDialog: React.FC<MessageActionExecutionDialogProps> = ({
  open,
  onClose,
  onExecute,
  action,
  actionArgs,
  onUpdateActionArg,
}) => {
  const handleExecute = () => {
    onExecute(actionArgs)
    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
        },
      }}
    >
      <DialogTitle>
        <Typography variant="h4" component="div" sx={{ fontWeight: 'bold' }}>
          Action Arguments
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 1 }}>
          <Stack spacing={3}>
            {action?.definition.args.map(arg => (
              <Box key={arg.key}>
                <Typography
                  variant="body2"
                  sx={{
                    mb: 1,
                    fontWeight: 500,
                    color: 'text.secondary',
                  }}
                >
                  {arg.description}
                </Typography>
                <TextField
                  fullWidth
                  variant="outlined"
                  value={actionArgs[arg.key] || ''}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    onUpdateActionArg(arg.key, e.target.value)
                  }}
                  placeholder={`Enter ${arg.description.toLowerCase()}`}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 1,
                    },
                  }}
                />
              </Box>
            ))}
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
        <Button onClick={onClose} variant="secondary">
          Cancel
        </Button>
        <Button onClick={handleExecute} variant="primary">
          Execute Action
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default MessageActionExecutionDialog
